import { ProductOffering } from '@travelwin/core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const useFilteredProducts = (
  products: ProductOffering[],
  searchParams: URLSearchParams,
) => {
  const { t } = useTranslation();
  const filteredProducts = useMemo(() => {
    const selectedPlans = searchParams.getAll(t('categories.plan', 'Plan'));
    const selectedDataCategories = searchParams.getAll(
      t('categories.data', 'Data'),
    );
    const selectedPlanLengths = searchParams.getAll(
      t('categories.planLength', 'Days'),
    );
    const selectedPrices = searchParams.getAll(t('categories.price', 'Price'));

    return products?.filter((product) => {
      let matchesPlan = true;
      if (selectedPlans.length > 0) {
        if (
          selectedPlans.includes('data-only') &&
          selectedPlans.includes('data-calls-texts')
        ) {
          matchesPlan = true;
        } else if (selectedPlans.includes('data-only')) {
          matchesPlan =
            product.call_minutes === 0 &&
            product.call_minutes_international === 0;
        } else if (selectedPlans.includes('data-calls-texts')) {
          matchesPlan =
            product.call_minutes !== 0 ||
            product.call_minutes_international !== 0;
        } else {
          matchesPlan = false;
        }
      }

      let matchesDataCategory = true;
      if (selectedDataCategories.length > 0) {
        matchesDataCategory = selectedDataCategories.includes('Unlimited')
          ? product.data === -1
          : true;
      }

      let matchesPlanLength = true;
      if (selectedPlanLengths.length > 0) {
        matchesPlanLength = selectedPlanLengths.some((length) => {
          if (length === 'any-length') {
            return true;
          }
          if (length === '1to7Days') {
            return product.bundle_validity <= 7;
          }
          if (length === '8to30Days') {
            return product.bundle_validity > 7 && product.bundle_validity <= 30;
          }
          if (length === '31PlusDays') {
            return product.bundle_validity > 30;
          }
          return false;
        });
      }

      let matchesPrice = true;
      if (selectedPrices.length > 0) {
        matchesPrice = selectedPrices.some((price) => {
          if (price === 'anyPrice') {
            return true;
          }
          if (price === '0to20') {
            return product.product_offering_pricing[0].total_price_gross <= 20;
          }
          if (price === '20To40') {
            return (
              product.product_offering_pricing[0].total_price_gross > 20 &&
              product.product_offering_pricing[0].total_price_gross <= 40
            );
          }
          if (price === '40Plus') {
            return product.product_offering_pricing[0].total_price_gross > 40;
          }
          return false;
        });
      }

      return (
        matchesPlan && matchesDataCategory && matchesPlanLength && matchesPrice
      );
    });
  }, [products, searchParams]);

  return filteredProducts;
};

export default useFilteredProducts;
